var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRouter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.000000 48.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,48.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172 429 c-48 -14 -109 -80 -123 -131 -23 -89 12 -182 88 -229 57 -36 154 -34 210 3 62 41 88 90 88 168 0 77 -26 127 -85 166 -43 29 -125 39 -178 23z m88 -59 c0 -22 5 -30 17 -30 14 0 12 -5 -10 -27 l-27 -28 -27 28 c-22 22 -24 27 -10 27 12 0 17 8 17 30 0 23 4 30 20 30 16 0 20 -7 20 -30z m-86 -103 l26 -23 -30 -29 c-23 -22 -30 -25 -30 -12 0 12 -9 17 -30 17 -23 0 -30 4 -30 20 0 16 7 20 30 20 20 0 30 5 30 15 0 20 2 19 34 -8z m197 -7 c22 0 29 -5 29 -20 0 -16 -7 -20 -30 -20 -21 0 -30 -5 -30 -17 0 -13 -7 -10 -30 12 l-30 29 27 24 c23 20 29 21 31 8 2 -10 14 -16 33 -16z m-106 -85 c29 -28 31 -35 10 -35 -10 0 -15 -10 -15 -30 0 -23 -4 -30 -20 -30 -16 0 -20 7 -20 30 0 20 -5 30 -15 30 -8 0 -15 2 -15 5 0 6 42 53 48 54 2 1 14 -10 27 -24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouter);
export default __webpack_public_path__ + "static/media/router.b212517a33e66064fee4d07cd22788d1.svg";
export { ForwardRef as ReactComponent };